import zh from 'iview/dist/locale/zh-CN'
import zhE from 'element-ui/lib/locale/lang/zh-CN'

const zhCn = Object.assign({
  menu: {
    home: '首页',
    system: '系统管理',
    system_management: {
      Role: '角色',
      Department: '部门',
      Account: '账号',
      WorkTime: '班次',
      WorkType: '工种',
      RoleEdit: '角色管理',
      DepartmentEdit: '部门编辑',
      AccountEdit: '账号编辑',
      WorkTimeEdit: '班次编辑',
      WorkTypeEdit: '工种编辑',
      systeminfo: '系统信息',
      SystemAuth: '授权管理'
    },
    Device: '设备管理',
    Device_management: {
      RouterList: '路由器',
      RouterEdit: '路由器编辑',
      Collector: '机台',
      CollectorEdit: '机台编辑',
      CollectorGroup: '机台分組',
      CollectorGroupEdit: '机台分组编辑'
    },
    Card: '卡片管理',
    CardEdit: '卡片编辑',
    People: '人员管理',
    PeopleEdit: '人员编辑',
    Product: '产品管理',
    ProductEdit: '产品编辑',
    Order: '订单管理',
    OrderEdit: '订单编辑',
    Plan: '排产管理',
    Plan_Management: {
      Production_plan: '订单计划安排',
      Production_management: '投(停)产管理',
      Production_order: '已排产订单'
    },
    Monitor: '实时监控',
    Monitor_Monitoring: {
      Collector: '机台监控',
      Order: '订单监控'
    },
    Data: '历史报表',
    Data_output: {
      Order: '订单统计',
      device: '设备统计',
      Worker: '人员统计',
      MaintainList: '维修管理',
      MaintainEdit: '维修编辑'
    },
    Setting: '个人设置'
  },
  system: {
    Account: {
      New_account: '新建账号',
      edit_account: '编辑账号',
      please_enter: '请输入',
      please_choose: '请选择',
      Return_to_account_list: '返回账号列表',
      User_name: '用户名',
      User_name_message: '请输入用户名',
      Name: '姓名',
      Name_message: '请输入姓名',
      Role: '角色',
      Role_message: '请选择角色',
      Worker_number: '工号',
      Department: '部门',
      Department_message: '请选择部门',
      Telephone: '电话',
      Email: '电子邮箱',
      QQ: 'QQ',
      Wechat: '微信',
      telephone: '电话：',
      email: '电邮：',
      qq: 'ＱＱ账号：',
      wechat: '微信账号：',
      save: '保存',
      index: '序号',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      reseat: '重設',
      error: '错误',
      error_message1: '<p>帳號重複</p>',
      error_message2: '<p>帳號重複</p>',
      delete_message: '确实要删除吗?'
    },
    Department: {
      New_Department: '新建部门',
      edit_Department: '编辑部门',
      index: '序号',
      Department: '部门',
      Authorization: '权限',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      Return_to_depatement_list: '返回部门列表',
      name: '名称',
      Move_left: '向左移动',
      Move_right: '向右移动',
      save: '保存',
      All_authorization: '全部权限',
      Department_authorization: '部门权限'
    },
    Role: {
      New_Role: '新建角色',
      edit_Role: '编辑角色',
      index: '序号',
      Role: '角色',
      Authorization: '权限',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      Return_to_role_list: '返回角色列表',
      name: '名称',
      Move_left: '向左移动',
      Move_right: '向右移动',
      save: '保存',
      All_authorization: '全部权限',
      Role_authorization: '角色权限'
    },
    workTime: {
      New_workTime: '新建班次',
      edit_workTime: '编辑班次',
      index: '序号',
      name: '名称',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      please_enter: '请输入',
      please_choose: '选择时间',
      startTime: '开始时间',
      endTime: '结束时间',
      Return_to_workTime_list: '返回班次列表',
      save: '保存'
    },
    workType: {
      New_workType: '新建工种',
      edit_workType: '编辑工种',
      index: '序号',
      name: '名称',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确实要删除吗?',
      please_enter: '请输入',
      Return_to_workType_list: '返回工种列表',
      save: '保存',
      yes: '是',
      no: '否',
      outputValid: '计算产量',
      monopoly: '独占机台',
      maintain: '维修模式',
      warn: '停机报警',
      Sorting: '排序',
      display: '显示看板',
      malfunction: '故障计算',
      remark: '备注'
    },
    SystemAuth: {
      Information: '基本信息',
      systemVersion: '系统版本:',
      systemDealTime: '到期日期:',
      please_enter: '请输入',
      save: '保存',
      save_success: '保存成功',
      systemAuthCode: '授权码:'
    },
    SystemInfo: {
      Information: '基本信息',
      Contect: '联系方式',
      systemName: '系统名称:',
      please_enter: '请输入',
      name: '企业名称:',
      contact: '联系人:',
      address: '企业地址',
      phone: '联络电话:',
      fax: '传真号码:',
      eMail: '电子邮箱:',
      save: '保存',
      save_success: '保存成功',
      warnLimitTime: '停机报警间隔:'
    }
  },
  device: {
    collector: {
      New_collector: '新建机台',
      edit_collector: '编辑机台',
      Return_to_collector_list: '返回机台列表',
      name: '名称',
      deviceNo: '编号',
      routerID: '路由器',
      type: '机器类型',
      computeType: '产能计算方式',
      roller: '滚筒',
      weft_density: '纬密',
      length: '滚筒周长',
      count: '条数',
      width: '出带宽度',
      deviceCompany: '机器制造商',
      deviceModel: '机器型号',
      buyTime: '机器购买时间',
      deviceLifeTime: '预估使用年限',
      please_enter: '请输入',
      please_enter_mm: '请输入(單位:mm)',
      save: '保存',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      error: '錯誤',
      error_message1: '<p>有資料未填寫</p>',
      error_message2: '必须整数',
      remark: '备注',
      Message: {
        name: '請輸入名稱',
        deviceNo: '請輸入編號',
        computeType: '請选择計算方式',
        routerID: '請选择所屬路由器',
        length: '請輸入滾筒周長',
        count: '請輸入條數',
        width: '請輸入出帶寬度'
      }
    },
    group: {
      New_group: '新建机器群组',
      edit_group: '编辑机器群组',
      Return_to_group_list: '返回机器群组列表',
      please_enter: '请输入',
      save: '保存',
      operating: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      index: '序号',
      name: '名称',
      chosen: '已选择',
      devices: '机器',
      remark: '备注',
      width: '寬度',
      router: '路由器'
    },
    router: {
      New_router: '新建路由器',
      edit_router: '编辑路由器',
      Return_to_router_list: '返回路由器列表',
      please_enter: '请输入',
      index: '序号',
      name: '路由器代号',
      AnotherName: '路由器名称',
      linkType: '联网模式',
      channel: '讯号频道',
      remark: '备注',
      save: '保存',
      action: '操作',
      edit: '编辑',
      delete: '删除',
      delete_message: '确定要删除吗?',
      mod: '联网模式',
      Lan: '局域网',
      Internet: '互联网',
      time: '重整',
      save_success: '系统与收集器重整完毕'
    }
  },
  Card: {
    New_Card: '新建卡片',
    edit_Card: '编辑卡片',
    Return_to_Card_list: '返回卡片列表',
    please_enter: '请输入',
    index: '序号',
    userName: '持有人',
    cardNo: '卡片编号',
    workTypeName: '工种',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    delete_message: '确定要删除吗?',
    save: '保存',
    error: '錯誤',
    error_message1: '<p>卡號重複</p>',
    error_message2: '<p>有資料未填寫</p>'
  },
  Product: {
    New_Product: '新建产品',
    edit_Product: '编辑产品',
    Return_to_Product_list: '返回产品列表',
    please_enter: '请输入',
    index: '序号',
    productNo: '编号',
    name: '名称',
    latDensity: '纬密',
    kaidu: '开度',
    width: '宽度',
    specifications: '规格',
    valid: '有效',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    delete_message: '确实要删除吗?',
    save: '保存',
    error: '錯誤',
    error_message: '<p>有資料未填寫</p>',
    please_enter_mm: '请输入（单位：mm）',
    please_enter_kaidu: '请输入（≧1）',
    please_enter_latDensity: '请输入（单位：纬/cm）',
    Message: {
      productNo: '请输入产品编号',
      name: '请输入名称',
      latDensity: '请输入纬密',
      kaidu: '请输入开度',
      width: '请输入宽度'
    }
  },
  Order: {
    New_Order: '新建订单',
    edit_Order: '编辑订单',
    Return_to_Order_list: '返回订单列表',
    please_enter: '请输入',
    please_enter_date: '请输入日期',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    error: '错误',
    error_message1: '<p>未添加產品至訂單</p>',
    error_message2: '<p>訂單資訊未填</p>',
    error_message3: '<p>數量未填</p>',
    error_message4: '<p>單位未填</p>',
    error_message5: '<p>交付未填</p>',
    error_message6: '<p>请先选择左侧产品</p>',
    delete_message: '确定要删除吗?',
    change_message: '确定要反結案吗?',
    orderNo: '订单編号',
    customer: '客户',
    ordersTime: '接单日期',
    salesman: '接单业务',
    index: '序号',
    productNo: '产品编号',
    num: '数量',
    unit: '单位',
    attritionRate: '耗损率(%)',
    deliveryTime: '订单交付日期',
    remark: '备注',
    add: '添加到订单',
    Product_list: '产品列表',
    search: '编号/名称',
    No_scheduling: '未排产',
    Not_production: '未投产',
    Producting: '已投产',
    Case_closed: '已结案',
    name: '名称',
    Meter: '米',
    Yard: '码',
    Gross: '箩',
    status: '状态',
    Message: {
      orderNo: '請輸入產品編號',
      ordersTime: '請輸入接单日期',
      customer: '請輸入客户名',
      salesman: '請輸入业务员'
    }
  },
  Login: {
    username: '请输入用户名',
    password: '请输入密码',
    systemCode: '请输入系统号',
    language: '請选择语言',
    login: '登录',
    system: '系统登录',
    changePw: '修改密码',
    logout: '退出登录',
    Information: '个人信息'
  },
  ChangePw: {
    oldPassword: '输入旧密码:',
    newPassword: '输入新密码:',
    comfirmPassword: '确认新密码:',
    save: '保存',
    error: '两次密码输入不一致',
    success: '修改成功',
    ChangePw: '修改密码'
  },
  monitor: {
    Collector: {
      index: '序号',
      name: '名称',
      group: '群组',
      deviceNo: '编号',
      rpm: '机器转速',
      status: '机器状态',
      status1: '设备状态',
      error: '故障讯息',
      worker: '刷卡人员',
      workType: '刷卡状态',
      lastTime: '时间',
      timeout: '离线',
      trial: '试运行',
      standby: '待排产',
      run: '生产中',
      orderNo: '订单',
      producNo: '货号',
      stop: ' 待机',
      warp: ' 经纱 ',
      weft: ' 纬纱 ',
      thread: ' 底线 ',
      roll: ' 卷取 '
    },
    Order: {
      index: '序号',
      orderNo: '订单',
      producNo: '货号',
      salesman: '业务',
      ordersTime: '接单时间',
      output: '产量',
      num: '订单量',
      unit: '单位',
      countdata: '机台数',
      name: '名称',
      rpm: '机器转速',
      worker: '刷卡人员',
      workType: '刷卡状态',
      DailyOutput: '今日產量',
      deliveryTime: '订单交期',
      today: '今日产量',
      completed: '已生产完成',
      fastestdelivery: '预估交期',
      please_enter_date1: '订单交期起始日期',
      please_enter_date2: '订单交期结束日期',
      Meter: '米',
      Yard: '码',
      Gross: '箩'
    }
  },
  data: {
    Device: {
      name: '机台',
      date: '日期',
      group: '群組',
      output: '产量',
      unit: '单位',
      runTotalTime: '运行时间',
      stopTime: '停机次数',
      stopTotalTime: '停机时间',
      error1Time: '经纱次数',
      error1TotalTime: '经纱时间',
      error2Time: '纬纱次数',
      error2TotalTime: '纬纱时间',
      error3Time: '底纱次数',
      error3TotalTime: '底纱时间',
      error4Time: '卷曲次数',
      error4TotalTime: '卷曲时间',
      S: '秒',
      M: '分',
      H: '时',
      D: '天',
      Meter: '米',
      output_report: '产能报表',
      run_report: '运行状况报表',
      please_enter: '请选择',
      please_enter_date: '请选择日期',
      start_date: '起始日期',
      end_date: '結束日期',
      ok: '确定',
      out: '輸出',
      status: '运行状况'
    },
    Order: {
      orderNo: '订单编号',
      productNo: '货号',
      collectorName: '机台名称',
      salesman: '接单业务',
      customer: '客户',
      ordersTime: '接单时间',
      productTime: '投产时间',
      output: '实际产量',
      target: '目標产量',
      num: '订单量',
      unit: '单位',
      deliveryTime: '客户交期',
      Meter: '米',
      Yard: '码',
      Gross: '箩',
      Order_report: '订单报表',
      ok: '确定',
      out: '輸出',
      please_enter: '请选择',
      please_enter_date: '请选择日期',
      start_date: '起始日期',
      end_date: '結束日期',
      time_range: '时间段',
      No_scheduling: '未排产',
      Not_production: '未投产',
      Producting: '已投产',
      Case_closed: '已结案',
      status: '状态',
      history: '历史订单'
    }
  },
  setting: {
    Basic_Information: '基本信息',
    company_information: '公司信息',
    Contact_information: '联系方式',
    save: '保存',
    please_enter: '请输入',
    username: '用户名:',
    name: '姓名:',
    company: '公司:',
    workNo: '工号:',
    department: '部门:',
    workPosition: '职位:',
    role: '角色:',
    phone: '电话:',
    eMail: '邮箱:',
    qq: 'QQ号码:',
    wechat: '微信:',
    System_setting: '系统配置',
    language: '语言:',
    zhcn: '简体中文',
    zhtw: '繁體中文',
    enUS: 'English',
    jaJP: '日本語',
    viVN: 'Việt Nam - Tiếng việt',
    thTH: 'ไทย - ไทย (แปรตรงตัว)'
  },
  plan: {
    Collector: {
      search: '机台筛选',
      name: '机台',
      one: '第一批',
      two: '第二批',
      three: '第三批',
      four: '第四批',
      fiv: '第五批',
      six: '第六批',
      orderNo: '订单号:',
      productNo: '产品号:',
      row: '条数:',
      delete_message: '确定是否停产?',
      yes: '投产',
      no: '停产'
    },
    Order: {
      orderNo: '订单号',
      customer: '客户',
      ordersTime: '接单日期',
      salesman: '业务员',
      index: '序号',
      productNo: '产品编号',
      num: '数量',
      unit: '单位',
      attritionRate: '耗损率(%)',
      output: '完成数',
      deliveryTime: '交付日期',
      action: '操作',
      Meter: '米',
      Yard: '码',
      Gross: '箩',
      delete_message: '确实是否结案?',
      case1: '结案',
      case2: '已结案'
    },
    Production: {
      productNo: '产品号',
      productName: '产品名称',
      deliveryTime: '客户交期',
      num: '数量',
      name: '机台名称',
      count: '条数',
      width: '宽度',
      collectorName: '机台名称',
      orderNo: '订单号',
      planIndex: '批次',
      row: '条数',
      action: '操作',
      delete: '删除',
      error: '錯誤',
      error_message: '<p>條數未选择</p>',
      planClick: '已排产计划列表',
      please_enter: '请输入',
      deviceNo: '编号',
      save: '确定',
      save1: '派单',
      save2: '插单',
      save3: '并产',
      No_scheduling: '未排产',
      Not_production: '未投产',
      Producting: '已投产',
      Case_closed: '已结案',
      status: '状态',
      no: '停产',
      delete_message: '确实要删除吗?',
      searchCollector: '机台名称',
      chooose_order: '1.选择订单',
      choose_device: '2.选择机台',
      choose_plan: '3.排产计划',
      list: '已排产计划列表',
      message: '此產品已經結案'
    }
  },
  People: {
    index: '序号',
    name: '姓名',
    workNo: '工号',
    sex: '性别',
    boy: '男',
    girl: '女',
    phone: '电话',
    entryTime: '入职时间',
    wechat: '微信号',
    qq: 'QQ号',
    working: '在职',
    working1: '在職',
    working2: '離職',
    yes: '是',
    no: '否',
    action: '操作',
    edit: '编辑',
    edit_People: '编辑人员',
    Return_to_People_list: '返回人员列表',
    please_enter: '请输入',
    please_enter_date: '选择日期',
    save: '保存'
  },
  Maintain: {
    index: '序号',
    DeviceName: '机器名称',
    username: '操作人员',
    startTime: '开始时间',
    endTime: '结束时间',
    remark: '备注',
    action: '操作',
    edit: '编辑',
    edit_Maintain: '编辑维修记录',
    Return_to_Maintain_list: '返回维修列表',
    save: '保存',
    please_enter: '请输入',
    please_enter_date1: '开始时间起始日期',
    please_enter_date2: '开始时间结束日期'
  },
  Permission: {
    super_admin: '超级系统管理',
    system: '系统管理',
    device: '设备管理',
    card: '卡片管理',
    people: '人员管理',
    product: '产品管理',
    order: '订单管理',
    production_plan: '排产管理',
    monitor: '实时监控',
    report_export: '历史报表',
    R: '读',
    W: '写',
    RW: '读写'
  }
}, zh, zhE)

export default zhCn



// WEBPACK FOOTER //
// ./src/lang/zh-cn.js